import React from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import './NotFound.css';

const NotFound = () => {
  return (
    <section className="not-found">
      <Container>
        <Row className="justify-content-center text-center">
          <Col lg={8}>
            <motion.div
              initial={{ opacity: 0, y: -20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
            >
              <div className="error-code">404</div>
              <h1>Page Not Found</h1>
              <p>The page you are looking for doesn't exist or has been moved.</p>
              <Link to="/">
                <Button variant="primary" className="btn btn-primary mt-3">
                  Back to Home
                </Button>
              </Link>
            </motion.div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default NotFound;